module.exports = __webpack_public_path__ + "c_static/img/C-2天猫-核对店铺.61c7b96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/电脑端轨迹加权/C-2天猫-核对店铺.jpg
// module id = +dTh
// module chunks = 33